export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-img2-a005dff6442399efa5399bd1a01c7711.jpg";